import React, { Suspense } from 'react';
import Loader from './loader';

export default function Loadable(HH) {
  return function Load(props) {
    return (
      <Suspense fallback={<Loader />}>
        <HH {...props} />
      </Suspense>
    );
  };
}
